export default {
    title: `Les essentiels`,
    subTitle: `L'activité économique vue par Alan Mudie, responsable de la stratégie d'investissement de Société Générale Private Banking.`,
    keyFigures: [
          {
            figure: 6,
            suffix: `%`,
            content: `Le gouvernement chinois a annoncé, lors de sa session parlementaire annuelle à Pékin, un objectif de croissance économique de 6 % pour l’année 2021. Le consensus des économistes sondés par l’agence Bloomberg prévoit même 8,4 %, un rythme de croissance que n’a pas connu la Chine depuis 2011.`,
            source: `Source : <a href="http://chine-magazine.com" target="_blank">chine-magazine.com</a>. Mars 2021.`,
            noCollapse: true,
        },

        {
            figure: 156000,
            suffix: `€`,
            content: `Un appartement neuf vient de se vendre 49 millions d’euros, soit un prix au mètre carré record de 156 000 euros. Ce logement de 313 mètres carrés et composé de cinq chambres est situé sur les hauteurs de Mid-Levels, quartier prisé de l’île de Hong Kong.`,
            source: `Source : <a href="http://lavieimmo.com" target="_blank">lavieimmo.com</a>. Février 2021.`,
            noCollapse: true,
        },

        {
            prefix: `+`,
            figure: 80,
            suffix: `%`,
            content: `C’est la hausse des ventes d’armes aux États-Unis au mois de janvier 2021 par rapport au mois de janvier 2020. L’État du Michigan figure en tête du classement avec une augmentation de 306 % suivi du New Jersey, avec une hausse de 248 %, et de Washington D.C., avec 202 %.`,
            source: `Source : <a href="http://courrierinternational.com" target="_blank">courrierinternational.com</a>. Janvier 2021.`,
            noCollapse: true,
            noMarge: true,
        },

        {   
            figure: 25.5,
            figureDecimals: 1,
            suffix: `%`,
            content: `Les femmes représentent, pour la première fois, plus d’un quart des parlementaires dans le monde.`,
            source: `Source : <a href="http://ipu.org" target="_blank">ipu.org</a>. Mars 2021.`,
            noCollapse: true,
            noMarge: true,
        },

        {
            figure: 18,
            suffix: `ans`,
            content: `C’est le temps qu’il a fallu à Tesla pour enfin être rentable et afficher un résultat net de 721 millions de dollars en 2020.`,
            source: `Source : <a href="http://lesechos.fr" target="_blank">lesechos.fr</a>. Janvier 2021.`,
            noCollapse: true,
        },

        {
            figure: 1,
            suffix: `<sup>re</sup>`,
            content: `Amsterdam devient la 1re Bourse européenne, en récupérant les transactions perdues par le Royaume-Uni depuis le Brexit. En moyenne, 9,2 milliards d’euros d’actions/jour ont été négociés sur ses plateformes en janvier, contre 8,6 milliards d’euros pour la City de Londres.`,
            source: `Source : <a href="http://lefigaro.fr" target="_blank">lefigaro.fr</a>. Février 2021.`,
            noCollapse: true,
            noMarge: true,
        },

        {
            figure: 38,
            suffix: `%`,
            content: `La production d’électricité européenne provenant des énergies renouvelables (solaire, éolien, hydraulique,bioénergies) a été de 38 % en 2020, dépassant pour la première foisles énergies fossilesque sont le gaz naturel et le charbon. `,
            source: `Source : <a href="http://lenergeek.com" target="_blank">lenergeek.com</a>. Janvier 2021.`,
            noCollapse: true,
            noMarge: true,
        },

        {
            figure: 3000,
            suffix: `%`,
            content: `Si l’Institut national des statistiques du Venezuela ne publie plus de chiffres sur l’inflation, celle-ci est estimée par de nombreux économistes à 3 000 % pour 2020. Afin de tenter de rattraper l’hyperinflation du pays, trois nouveaux billets de monnaie (200 000, 500 000 et 1 million de bolivars) sont entrés en circulation. Ensemble, ils ne valent pas 1 dollar.`,
            source: `Source : <a href="http://courrierinternational.com" target="_blank">courrierinternational.com</a>. Mars 2021`,
            noCollapse: true,
            noMarge: true,
        },

    ]
};

